export const EXTREME_INDICATORS = {
  humidity: { min: 6, max: 30 },
  gluten: { min: 6, max: 55 },
  idk: { min: 10, max: 110 },
  bug: { min: 0, max: 100 },
  protein: { min: 5, max: 20 },
  cp: { min: 60, max: 280 },
  nature: { min: 350, max: 900 },
};
